__turbopack_context__.v({
  "articlePageHeader": "oj3LCG_articlePageHeader",
  "authorContainer": "oj3LCG_authorContainer",
  "date": "oj3LCG_date",
  "hDivider": "oj3LCG_hDivider",
  "headerImage": "oj3LCG_headerImage",
  "headerImageColumn": "oj3LCG_headerImageColumn",
  "headerImageContainer": "oj3LCG_headerImageContainer",
  "shareBtns": "oj3LCG_shareBtns",
  "subtitle": "oj3LCG_subtitle",
  "title": "oj3LCG_title",
  "titlesAuthorsContainer": "oj3LCG_titlesAuthorsContainer",
});
